import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'sonner';
import { AuthProvider } from './lib/auth';
import AppLayout from './components/layout/AppLayout';
import ProtectedRoute from './components/ProtectedRoute';

import Home from './pages/Home';
import BuyTicket from './pages/BuyTicket';
import PaymentMock from './pages/PaymentMock';
import FAQ from './pages/FAQ';
import Winners from './pages/Winners';
import Terms from './pages/Terms';
import Login from './pages/Login';
import Signup from './pages/Signup';
import VerifyEmail from './pages/VerifyEmail';
import CheckEmail from './pages/CheckEmail';
import ForgotPassword from './pages/ForgotPassword';
import Dashboard from './pages/Dashboard';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import AdminUserDetail from './pages/AdminUserDetail';

import './App.css';

function Shell({ children }) {
  return <AppLayout>{children}</AppLayout>;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster
            position="top-right"
            theme="dark"
            richColors
            toastOptions={{ style: { background: '#141414', border: '1px solid rgba(212,175,55,0.3)', color: '#fff' } }}
          />
          <Routes>
            <Route path="/" element={<Shell><Home /></Shell>} />
            <Route path="/buy-ticket" element={<Shell><BuyTicket /></Shell>} />
            <Route path="/payment/mock" element={<Shell><PaymentMock /></Shell>} />
            <Route path="/faq" element={<Shell><FAQ /></Shell>} />
            <Route path="/winners" element={<Shell><Winners /></Shell>} />
            <Route path="/terms" element={<Shell><Terms /></Shell>} />

            <Route path="/login" element={<Shell><Login /></Shell>} />
            <Route path="/signup" element={<Shell><Signup /></Shell>} />
            <Route path="/verify-email" element={<Shell><VerifyEmail /></Shell>} />
            <Route path="/check-email" element={<Shell><CheckEmail /></Shell>} />
            <Route path="/forgot-password" element={<Shell><ForgotPassword /></Shell>} />

            <Route
              path="/dashboard"
              element={
                <Shell>
                  <ProtectedRoute>
                    <Dashboard />
                  </ProtectedRoute>
                </Shell>
              }
            />

            <Route path="/admin/login" element={<Shell><AdminLogin /></Shell>} />
            <Route
              path="/admin"
              element={
                <Shell>
                  <ProtectedRoute adminOnly>
                    <AdminDashboard />
                  </ProtectedRoute>
                </Shell>
              }
            />
            <Route
              path="/admin/users/:id"
              element={
                <Shell>
                  <ProtectedRoute adminOnly>
                    <AdminUserDetail />
                  </ProtectedRoute>
                </Shell>
              }
            />

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
